/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'view-hide': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<defs><path pid="0" d="M3.207.793L1.793 2.207 4.076 4.49C1.2 6.838 0 10 0 10s3 8 11 8c2.076 0 3.806-.545 5.242-1.344l2.551 2.551 1.414-1.414-17-17zM11 2c-1.212 0-2.294.2-3.283.512l2.56 2.56C10.514 5.037 10.753 5 11 5a5 5 0 015 5c0 .247-.037.486-.072.723l3.43 3.43C21.203 12.102 22 10 22 10s-3-8-11-8zM6.834 7.248l1.463 1.463C8.108 9.1 8 9.537 8 10a3 3 0 003 3c.463 0 .9-.108 1.29-.297l1.462 1.463A4.96 4.96 0 0111 15a5 5 0 01-5-5c0-1.02.31-1.962.834-2.752z" id="svgicon_view-hide_a"/></defs><g transform="translate(1 2)" _fill="none" fill-rule="evenodd"><mask id="svgicon_view-hide_b" _fill="#fff"><use xlink:href="#svgicon_view-hide_a"/></mask><use _fill="#000" fill-rule="nonzero" xlink:href="#svgicon_view-hide_a"/><path pid="1" _fill="#242628" mask="url(#svgicon_view-hide_b)" d="M-1-2h24v24H-1z"/></g>'
  }
})
